import { KpopStudyPageTemplate } from "@/components/KpopStudyPageTemplate";

const StudyWithNCT = () => {
  return (
    <KpopStudyPageTemplate
      groupName="NCT"
      groupNameDisplay="NCT"
      fandomName="NCTzens"
      seoTitle="Study With NCT - NCT Study Rooms"
      seoDescription="Study with NCT fans worldwide. Join NCTzens in virtual study rooms with NCT playlists and productivity tools."
      seoKeywords="study with nct, nct study room, nctzen study, kpop study room, nct 127, nct dream"
      canonicalUrl="/study-with-nct/"
      heroDescription="Join a global community of NCTzens who combine their passion for NCT with productive study sessions."
      aboutContent={
        <>
          <p>
            <a href="https://nct.smtown.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">NCT</a> (Neo Culture Technology) is a South Korean boy band formed by <a href="https://www.smentertainment.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">SM Entertainment</a> in 2016. NCT operates with an unlimited number of members divided into sub-units.
          </p>
          <p>
            NCT's fanbase, known as NCTzen, spans across the globe. Follow them on <a href="https://www.instagram.com/nct/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Instagram</a>, <a href="https://twitter.com/NCTsmtown" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">X (Twitter)</a>, and <a href="https://www.youtube.com/@NCT" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">YouTube</a>.
          </p>
        </>
      }
      riseOfContent={
        <p>
          NCT fans have created spaces to combine their passion with productive study sessions, playing <a href="https://open.spotify.com/artist/48eO052eSDcn8aTxiv6QaG" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">NCT's music on Spotify</a> in the background.
        </p>
      }
      featureCards={[
        { title: "NCT Study Playlists", desc: "Curated playlists from all NCT units to keep you motivated." },
        { title: "Connect with NCTzens", desc: "Meet fellow NCTzens from around the world who share your bias." },
        { title: "Neo-Themed Rooms", desc: "Study rooms with NCT-inspired futuristic aesthetics." },
        { title: "Multi-Unit Sessions", desc: "Choose rooms themed around your favorite NCT unit." },
      ]}
      whyPerfectDescription="CSW is more than just a study platform; it's a place where fans of NCT can come together, stay motivated, and achieve their goals."
      communityDescription1="CSW – Chill Study Work is more than just a study platform; it's a place to connect with like-minded individuals."
      communityDescription2="Discover how studying with your favorite idols can transform your academic journey."
      socialLinks={[
        { name: "Official Website", url: "https://nct.smtown.com/" },
        { name: "YouTube", url: "https://www.youtube.com/@NCT" },
        { name: "Instagram", url: "https://www.instagram.com/nct/" },
        { name: "X (Twitter)", url: "https://twitter.com/NCTsmtown" },
        { name: "Spotify", url: "https://open.spotify.com/artist/48eO052eSDcn8aTxiv6QaG" },
      ]}
      youtubeVideos={[
        { id: "0AUFyFEt35g", title: "NCT 127 - Kick It M/V" },
        { id: "vNm_-e0n5-M", title: "NCT DREAM - ISTJ M/V" },
        { id: "MUdTjqMttHQ", title: "NCT 127 - Fact Check M/V" },
        { id: "wHaB3jEeuJY", title: "NCT DREAM - Candy M/V" },
        { id: "pFE5rG-gE5s", title: "NCT 127 - 2 Baddies M/V" },
        { id: "DmD04RAYJAk", title: "NCT DREAM - Smoothie M/V" },
      ]}
      youtubeChannelUrl="https://www.youtube.com/@NCT"
      youtubeChannelName="NCT"
    />
  );
};

export default StudyWithNCT;
